import React from "react";
import './css/HeroSecStyle.css';
import { Link } from "react-router-dom";

function HeroSection(){
    return (
        <section className="hero-banner d-flex align-items-center justify-content-center text-center text-white">
  `         <div className="overlay"></div>
            <div className="content position-relative">
                <h1 className="display-5 fw-bold">Contact Us</h1>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center">
                        <li className="breadcrumb-item"><Link to="/" class="text-white text-decoration-none">Home</Link></li>
                        <li className="breadcrumb-item active text-white" aria-current="page">Contact Us</li>
                    </ol>
                </nav>
            </div>
        </section>
    )
}

export default HeroSection;